import { bool, node, oneOf, string } from 'prop-types';
import React from 'react';
import { themes } from '@ids/theme';
import { styleOverrideReason } from '@ids/core';
import { HeaderWrapper } from './StyledModalDialog';

/** */
// eslint-disable-next-line react/function-component-definition
export default function ModalHeader(props) {
  // eslint-disable-next-line react/prop-types
  const { backgroundColor, children, style } = props;

  return (
    <HeaderWrapper {...props} style={{ backgroundColor, ...style }}>
      {children}
    </HeaderWrapper>
  );
}

ModalHeader.propTypes = {
  /**
   * Alignment of header
   */
  alignment: oneOf(['center', 'left']),
  /**
   * Custom header background color
   */
  backgroundColor: string,
  /**
   * Inner content of modal header
   */
  children: node,
  /**
   * Unique id for aria-labelledby
   */
  id: string,
  /**
   * When `style` or `className` prop is provided, provide the reason behind the override.
   */
  styleOverrideReason,
  /**
   * When there is an application level theme defined, use this prop to override
   * (e.g. 'mint', 'proconnect', 'quickbooks', 'turbotax')
   */
  theme: oneOf(themes),
  /**
   * Turns off header background color
   */
  // eslint-disable-next-line react/boolean-prop-naming
  transparentBackground: bool
};

ModalHeader.defaultProps = {
  alignment: 'center',
  backgroundColor: '',
  children: null,
  id: '',
  styleOverrideReason: undefined,
  theme: undefined,
  transparentBackground: true
};

ModalHeader.displayName = 'ModalHeader';
